import FeatureScheduleDetailspage from "./feature-schedule-details/feature-schedule-details";

function FeatureScheduleDetailsLandingPage() {
  return <FeatureScheduleDetailspage />;
}

export default FeatureScheduleDetailsLandingPage;
